export function getTemplateContent(template) {
  return template?.content || {};
}

export function getTemplateDefaults(template) {
  const content = getTemplateContent(template);
  return content.defaults || content;
}

export function normalizeOperationalTemplate(template) {
  const content = getTemplateContent(template);
  return {
    ...template,
    defaults: content.defaults || content,
    items: content.items || [],
    taskTemplateGroups: content.taskTemplateGroups || [],
  };
}

export function convertHoursToMilliseconds(items = []) {
  return items.map((item) => ({
    ...item,
    quotedHours: Number(item.quotedHours || 0) * 60 * 60 * 1000,
  }));
}

export function convertMillisecondsToHours(items = []) {
  return items.map((item) => ({
    ...item,
    quotedHours: item.quotedHours ? item.quotedHours / (60 * 60 * 1000) : 0,
  }));
}

export function mergeEmptyFields(target = {}, defaults = {}) {
  return Object.entries(defaults).reduce(
    (acc, [key, value]) => {
      const existingValue = acc[key];
      const hasValue =
        existingValue !== undefined &&
        existingValue !== null &&
        existingValue !== "";

      if (hasValue || value === undefined || value === null || value === "") {
        return acc;
      }

      return { ...acc, [key]: value };
    },
    { ...target }
  );
}

export function buildTemplatePayload({
  type,
  form,
  defaults,
  items,
  taskTemplateGroups,
  appType,
}) {
  return {
    type,
    name: form.name?.trim(),
    description: form.description?.trim() || "",
    content: {
      defaults,
      items: items || [],
      taskTemplateGroups: taskTemplateGroups || [],
    },
    metadata: {
      templateFamily: type,
      schemaVersion: 2,
      appType,
    },
  };
}

export function templateMatchesAppType(template, appType) {
  const templateAppType = template?.metadata?.appType;
  return !appType || !templateAppType || templateAppType === appType;
}
